export const setMood = (value: number) => {
  switch (true) {
    case value < 0.333:
      return 'negative';
    case value < 0.666:
      return 'neutral';
    default:
      return 'positive';
  }
};
